import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { SubscriptionCategory } from '../../../../../../common/enums.js';
import { EoeSubscriptionDetailsBroadband } from '../../../../../../components/EoeSubscriptionDetails/EoeSubscriptionDetailsBroadband.js';
import {
  checkValidEmployeeSubscription,
  getEmployeeSubscriptions,
} from '../../../../../../selfservice/actions/index.js';
import type { SubscriptionId } from '../../../../../../common/constants/pathInterfaces.js';

export const EoeBroadbandSubPath = () => {
  const dispatch = useDispatch();
  const { subscriptionId = '' } = useParams<SubscriptionId>();

  useEffect(() => {
    dispatch(getEmployeeSubscriptions(SubscriptionCategory.BROADBAND, subscriptionId));
    dispatch(checkValidEmployeeSubscription(SubscriptionCategory.BROADBAND, subscriptionId));
  }, [dispatch, subscriptionId]);

  return <EoeSubscriptionDetailsBroadband subscriptionId={subscriptionId} />;
};
